var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 0) scale(-2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 73.41 70 c -4.155 0 -7.536 -3.381 -7.536 -7.537 s 3.381 -7.537 7.536 -7.537 c 4.156 0 7.537 3.381 7.537 7.537 S 77.566 70 73.41 70 z M 73.41 56.926 c -3.053 0 -5.536 2.484 -5.536 5.537 S 70.357 68 73.41 68 s 5.537 -2.484 5.537 -5.537 S 76.463 56.926 73.41 56.926 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.453 70 c -4.156 0 -7.537 -3.381 -7.537 -7.537 s 3.381 -7.537 7.537 -7.537 s 7.537 3.381 7.537 7.537 S 17.609 70 13.453 70 z M 13.453 56.926 c -3.053 0 -5.537 2.484 -5.537 5.537 S 10.4 68 13.453 68 c 3.053 0 5.537 -2.484 5.537 -5.537 S 16.506 56.926 13.453 56.926 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85.471 63.487 l -5.535 -0.024 c -0.552 -0.007 -0.994 -0.459 -0.988 -1.012 c 0.006 -0.552 0.413 -0.991 1.012 -0.988 l 5.512 0.024 c 1.395 0 2.529 -1.135 2.529 -2.529 V 47.134 c 0 -8.696 -3.385 -20.943 -10.91 -20.943 h -7.813 c -0.089 0 -0.177 -0.012 -0.262 -0.035 L 54.85 22.309 v 29.468 c 0 0.553 -0.447 1 -1 1 H 3.373 C 2.616 52.776 2 53.392 2 54.148 v 4.176 c 0 0.846 0.33 1.64 0.928 2.236 c 0.596 0.596 1.388 0.923 2.231 0.923 c 0.002 0 0.004 0 0.007 0 l 1.739 -0.021 c 0.517 0.004 1.005 0.437 1.012 0.988 s -0.436 1.005 -0.988 1.012 l -1.749 0.021 c -0.004 0 -0.008 0 -0.012 0 c -1.385 0 -2.679 -0.535 -3.652 -1.507 C 0.538 61.002 0 59.704 0 58.324 v -4.176 c 0 -1.859 1.513 -3.372 3.373 -3.372 H 52.85 V 21 c 0 -0.312 0.146 -0.605 0.393 -0.794 c 0.249 -0.189 0.572 -0.251 0.869 -0.17 l 15.299 4.155 h 7.68 c 9.472 0 12.91 13.721 12.91 22.943 v 11.824 C 90 61.455 87.968 63.487 85.471 63.487 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.874 63.463 H 39.895 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 26.979 c 0.553 0 1 0.447 1 1 S 67.427 63.463 66.874 63.463 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.41 63.46 c -0.13 0 -0.261 -0.021 -0.38 -0.07 c -0.131 -0.05 -0.23 -0.13 -0.33 -0.22 c -0.19 -0.19 -0.29 -0.44 -0.29 -0.71 c 0 -0.13 0.029 -0.26 0.08 -0.38 c 0.05 -0.12 0.119 -0.23 0.21 -0.32 c 0.369 -0.38 1.05 -0.38 1.42 0 c 0.09 0.09 0.16 0.2 0.21 0.32 s 0.08 0.25 0.08 0.38 c 0 0.27 -0.101 0.52 -0.29 0.71 c -0.101 0.09 -0.21 0.17 -0.33 0.22 S 73.54 63.46 73.41 63.46 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.45 63.46 c -0.13 0 -0.26 -0.021 -0.38 -0.07 s -0.23 -0.13 -0.32 -0.22 c -0.1 -0.09 -0.17 -0.2 -0.22 -0.32 s -0.08 -0.25 -0.08 -0.39 c 0 -0.26 0.11 -0.521 0.3 -0.7 c 0.36 -0.38 1.04 -0.38 1.41 0 c 0.19 0.18 0.29 0.44 0.29 0.7 c 0 0.14 -0.02 0.26 -0.07 0.39 c -0.05 0.12 -0.13 0.23 -0.22 0.32 c -0.09 0.09 -0.2 0.17 -0.32 0.22 C 13.71 63.439 13.59 63.46 13.45 63.46 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.815 44.396 H 69.276 c -0.553 0 -1 -0.448 -1 -1 V 25.191 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 17.205 h 18.539 c 0.553 0 1 0.448 1 1 S 89.368 44.396 88.815 44.396 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.358 70 c -4.156 0 -7.537 -3.381 -7.537 -7.537 s 3.381 -7.537 7.537 -7.537 s 7.537 3.381 7.537 7.537 S 37.514 70 33.358 70 z M 33.358 56.926 c -3.053 0 -5.537 2.484 -5.537 5.537 S 30.305 68 33.358 68 c 3.053 0 5.537 -2.484 5.537 -5.537 S 36.411 56.926 33.358 56.926 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.36 63.46 c -0.27 0 -0.52 -0.101 -0.71 -0.29 c -0.09 -0.09 -0.17 -0.2 -0.22 -0.32 c -0.05 -0.13 -0.07 -0.25 -0.07 -0.39 c 0 -0.26 0.1 -0.521 0.29 -0.7 c 0.37 -0.38 1.04 -0.38 1.41 0 c 0.19 0.18 0.3 0.44 0.3 0.7 c 0 0.14 -0.03 0.26 -0.08 0.39 c -0.05 0.12 -0.12 0.23 -0.22 0.32 c -0.09 0.09 -0.2 0.17 -0.32 0.22 S 33.49 63.46 33.36 63.46 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.821 63.463 H 19.99 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 6.831 c 0.552 0 1 0.447 1 1 S 27.374 63.463 26.821 63.463 z",
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 140,
    width: 100,
    height: 20,
    fill: "",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 55,
    fontFamily: "Arial",
    fontSize: 10,
    fill: "black"
  }, "Electric"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truckIcon.69d4019ab7edad067197e25b54136ce4.svg";
export { ForwardRef as ReactComponent };